<template>
<div :id="$style.login">
  <Header nav="false" center="false" />
  <div :class="$style.auth">
    <h2>Please Login</h2>
    <button class="btn" v-on:click="signIn">Continue With Google</button>
  </div>
</div>
</template>

<script>
  import Auth from '../../auth'
  import Header from '../lib/Header'

  export default {
    name: 'Login',
    components: {
      Header
    },
    methods: {
      signIn () {
        Auth.signInWithGoogle()
      }
    },
    computed: {
      signInFail () {
        return this.$store.state.signInFail
      }
    },
    watch: {
      signInFail () {
        if (this.$store.state.signInFail) {
          this.$toasted.show(`Login failed: ${this.$store.state.signInFail}`, {
            duration: 3000,
            className: 'toasty-error'
          })
        }
      }
    }
  }
</script>

<style lang="scss" module>
  .auth {
    padding: 20px 20px 40px;
    background-color: white;
    max-width: 400px;
    margin: 80px auto;
    text-align: center;
    border-radius: 8px;
    -webkit-box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
    box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);

    h2 {
      margin-bottom: 40px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Login/index.vue